import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable, Type, Component } from '@angular/core';
import { CommonDataService } from './CommonDataService';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import { isUndefined, isNullOrUndefined } from '../objectUtils';

export interface DomainAndVariables {
  variables: any,
  domains: models.DomainVM[]
}
export function CommonData(domainCode: string) {
  return function (target: Object, key: string | symbol) {
    //console.log(`Associating domainCode ${domainCode} to property ${String(key)} of object: ${target.constructor.name}`);
    if (target.constructor["[[commonDataProps]]"] == null) {
      target.constructor["[[commonDataProps]]"] = {};
    }

    target.constructor["[[commonDataProps]]"][key] = domainCode;
  }
}

@Injectable({ providedIn: "root" })
export class CommonDataResolver implements Resolve<DomainAndVariables> {
  constructor(private commonDataService: CommonDataService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DomainAndVariables> {
    if (route.component == null) {
      return of(null);
    }
    if (typeof route.component !== "function") {
      throw `CommonDataResolver can only be used with route.component as Object: ${route.url} is associated with string: ${route.component}`;
    }

    return CommonDataResolver.resolveCommonDataForComponent(<Type<any>>route.component, this.commonDataService);
  }

  public static resolveCommonDataForComponent(component: Type<any>, commonDataService: CommonDataService): Observable<DomainAndVariables> {
    let commonDataProps = component["[[commonDataProps]]"];
    if (commonDataProps == null)
      return of(null);
    //console.log(`CommonDataProps ${commonDataProps}`);
    //console.log(commonDataProps);

    let domainsToLoad = Object.keys(commonDataProps).map(prop => commonDataProps[prop]);
    //console.log("DomainsToLoad");
    //console.log(domainsToLoad);

    return commonDataService.getDomains(domainsToLoad)
      .pipe(map(result => {
        //console.log("Received domains result");
        //console.log(result);

        result.forEach(domain => {
          //console.log(`Updating '${this.translate.currentLang}' translations for domainCode ${domain.domainCode}`);
          //this.translate.setTranslation(this.translate.currentLang, this.buildTranslationsForDomain(domain), true);
          //console.log(`Setting domain ${domain.domainCode}`);
          //console.log(commonDataProps);

          let componentProp = Object.keys(commonDataProps).find(key => commonDataProps[key] === domain.domainCode);
          //console.log(`componentProp ${componentProp}`);
          //console.log(`Setting value of property ${componentProp} with dimensions from ${domain.domainCode}`);
          Object.defineProperty(component.prototype, componentProp, {
            configurable: true,
            enumerable: true,
            get: () => domain.dimensions
          });
        });

        const newResult: DomainAndVariables = { variables: commonDataProps, domains: result }
        return newResult;
      }));
  }

  public static getParentComponentCommonData(child: any, parent: any): void {
    let childCommonDataProps = child.constructor["[[commonDataProps]]"];
    if (!isNullOrUndefined(childCommonDataProps)) {
      Object.keys(childCommonDataProps).forEach(prop => {
        //log vs throw ??
        if (isNullOrUndefined(parent[prop]))
          console.log(`Failed to set child (${child.constructor.name}) common data (${prop}) from parent (${parent.constructor.name}). Children dimensions must exist on parent`);
        else
          child[prop] = [...parent[prop]];
      });
    }
  }


}
